//==============================================
// App Scripts
//==============================================


import {nav} from './modules/nav.js';
import * as header from './modules/components/nav-header.js';
import * as scroll from './modules/scroll.js';
import * as video from './modules/components/video-player.js';
import * as popup from './modules/components/popup.js';
//import {initFooterScroll} from './modules/footer.js';
import {iframeResise} from './modules/utils.js';
import {homeSections} from './modules/home-sections-scroll.js';
import {pageSections} from './modules/sections-scroll.js';

(function ($) {

    $( () => {
        
        gsap.registerPlugin(ScrollTrigger);

        nav();

        scroll.scrollHeader();
        scroll.scrollTopButton();
        scroll.scrollTopButtonVisible();
        scroll.scrollDownHome();
        scroll.jumpLinks();

        header.headerScroll();
        header.headerInit();

        video.videoPlayer();
        popup.popups();

        //initFooterScroll();

        iframeResise();
        homeSections();
        pageSections();

    });

})(jQuery);